// src/pages/Latest-Law.jsx - COMPACT VERSION
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../services/apiService';

const LatestLaw = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const latestLaw = [
    {
      title: 'Latest Case-Law',
      description: 'Daily Supreme Court & High Court Rulings with Quick Summaries.',
      icon: '/Images/LatestJudgments.png',
      link: 'Case-Law',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: '#667eea'
    },
    {
      title: 'Latest Law Points',
      description: 'Fresh, concise legal principles extracted from New Judgments',
      icon: '/Images/Latestlawpoints.png',
      link: 'Latest-LawPoints',
      isLink: true,
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      color: '#f093fb'
    },
    
  ];

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}${day}${month}`;
  }

  const handleLatestLawEvent = async (event) => {
    setIsLoading(true);
    try {
      if (event === 'News') {
        navigate('/News');
      } else if (event === 'Latest-LawPoints') {
        navigate('/Latest-LawPoints');
      } else if (event === 'Notification') {
        navigate('/Notification');
      } else if (event === 'Case-Law') {
        const payload = {
          requests: [{
            yearFrom: 2025,
            yearTo: 2025,
            mainkeys: ['ALL']
          }],
          sortBy: "year",
          sortOrder: "desc",
          page: 1,
          pageSize: 25,
          inst: '',
          prompt: "Database",
        };

        const apiResponse = await ApiService.executeAllSearch(payload);

        const resultsData = {
          results: apiResponse.hits || [],
          totalCount: apiResponse.total || 0,
          query: '',
          searchType: 'Latest Search',
          timestamp: new Date().toISOString(),
          courtsList: apiResponse.courtsList || [],
          yearList: apiResponse.yearList || [],
          searchData: {
            query: '',
            searchType: 'Latest Search',
            sortOrder: 'year',
            searchIn: 'B',
            nearWordsDistance: '5'
          }
        };
        localStorage.setItem('searchResults', JSON.stringify(resultsData));
        navigate('/results');
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="latest-law-page">
      {/* Compact Hero Section */}
      <div className="latest-hero">
        <div className="hero-content-wrapper">
          <h1 className="latest-hero-title">
            Latest in <span className="gradient-text-latest">Law</span>
          </h1>
          <p className="latest-hero-subtitle">
            Stay informed with the most recent legal developments and official notifications
          </p>
        </div>
        
        <div className="hero-bg-elements">
          <div className="bg-circle bg-circle-1"></div>
          <div className="bg-circle bg-circle-2"></div>
        </div>
      </div>

      {/* Main Content */}
      <div className="latest-container">
        {/* Categories Grid */}
        <div className="categories-grid">
          {latestLaw.map((category, index) => (
            <div
              key={index}
              className="category-card"
              onClick={() => handleLatestLawEvent(category.link)}
              style={{ '--card-gradient': category.gradient, '--card-color': category.color }}
            >
              <div className="category-card-inner">
                <div className="category-icon-wrapper">
                  <div className="icon-glow"></div>
                  <img
                    src={category.icon}
                    alt={category.title}
                    className="category-icon-img"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = '<i class="bx bx-file-blank" style="font-size: 56px; color: var(--card-color);"></i>';
                    }}
                  />
                </div>
                
                <div className="category-content">
                  <h3 className="category-title">{category.title}</h3>
                  <p className="category-description">{category.description}</p>
                </div>

                <div className="category-footer">
                  <span className="view-more">
                    View Updates
                    <i className="bx bx-right-arrow-alt"></i>
                  </span>
                </div>
              </div>

              <div className="card-shine"></div>
            </div>
          ))}
        </div>

        {/* Bottom Info */}
        <div className="bottom-info">
          <p className="info-text">
            All updates are sourced from official government publications and verified legal databases
          </p>
        </div>
      </div>

      {/* Loading Overlay */}
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      )}

      <style jsx>{`
        .latest-law-page {
          min-height: 100vh;
          background: #fafafa;
        }

        /* Compact Hero Section */
        .latest-hero {
          position: relative;
          background: linear-gradient(135deg, #E91E63 0%, #E91E64 50%, #c41849 100%);
          padding: 60px 20px;
          text-align: center;
          overflow: hidden;
          z-index: 1;
        }

        .hero-content-wrapper {
          position: relative;
          z-index: 2;
          max-width: 800px;
          margin: 0 auto;
        }

        .latest-hero-title {
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 800;
          color: white;
          margin-bottom: 16px;
          line-height: 1.2;
        }

        .gradient-text-latest {
          display: inline-block;
          background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .latest-hero-subtitle {
          font-size: clamp(0.95rem, 2vw, 1.1rem);
          color: rgba(255, 255, 255, 0.95);
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .hero-bg-elements {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          z-index: 1;
        }

        .bg-circle {
          position: absolute;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
        }

        .bg-circle-1 {
          width: 250px;
          height: 250px;
          top: -80px;
          right: -60px;
          animation: float 18s infinite ease-in-out;
        }

        .bg-circle-2 {
          width: 180px;
          height: 180px;
          bottom: -40px;
          left: -40px;
          animation: float 22s infinite ease-in-out reverse;
        }

        @keyframes float {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(-20px, -20px) scale(1.08); }
        }

        /* Main Container */
        .latest-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 50px 20px;
          position: relative;
          z-index: 10;
        }

        /* Categories Grid - More Compact */
        .categories-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 24px;
          margin-bottom: 50px;
        }

        .category-card {
          position: relative;
          background: white;
          border-radius: 20px;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        }

        .category-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: var(--card-gradient);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .category-card:hover::before {
          opacity: 1;
        }

        .category-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 40px rgba(245, 166, 35, 0.18);
        }

        .category-card-inner {
          padding: 28px 24px 24px;
        }

        .category-icon-wrapper {
          position: relative;
          width: 90px;
          height: 90px;
          margin: 0 auto 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.08), rgba(233, 30, 99, 0.08));
          border-radius: 18px;
          transition: all 0.3s ease;
        }

        .category-card:hover .category-icon-wrapper {
          transform: scale(1.08) rotate(-3deg);
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.12), rgba(233, 30, 99, 0.12));
        }

        .icon-glow {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 110px;
          height: 110px;
          background: var(--card-gradient);
          border-radius: 50%;
          opacity: 0;
          filter: blur(25px);
          transition: opacity 0.3s ease;
        }

        .category-card:hover .icon-glow {
          opacity: 0.25;
        }

        .category-icon-img {
          width: 60px;
          height: 60px;
          object-fit: contain;
          position: relative;
          z-index: 2;
        }

        .category-content {
          text-align: center;
          margin-bottom: 20px;
        }

        .category-title {
          font-size: 1.4rem;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 10px;
          transition: all 0.3s ease;
        }

        .category-card:hover .category-title {
          background: var(--card-gradient);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .category-description {
          font-size: 0.95rem;
          color: #6b7280;
          line-height: 1.5;
          margin: 0;
        }

        .category-footer {
          display: flex;
          justify-content: center;
          padding-top: 16px;
          border-top: 1px solid #f0f0f0;
        }

        .view-more {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: var(--card-color);
          font-size: 0.95rem;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .view-more i {
          font-size: 18px;
          transition: transform 0.3s ease;
        }

        .category-card:hover .view-more i {
          transform: translateX(5px);
        }

        .card-shine {
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          transform: rotate(45deg);
          opacity: 0;
          transition: opacity 0.6s ease;
        }

        .category-card:hover .card-shine {
          opacity: 1;
          animation: shine 1.2s ease;
        }

        @keyframes shine {
          0% { transform: translateX(-100%) rotate(45deg); }
          100% { transform: translateX(100%) rotate(45deg); }
        }

        /* Bottom Info */
        .bottom-info {
          text-align: center;
          padding-top: 30px;
          border-top: 1px solid #e5e7eb;
        }

        .info-text {
          font-size: 0.95rem;
          color: #6b7280;
          margin: 0;
          line-height: 1.6;
        }

        /* Loading Overlay */
        .loading-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .loading-spinner {
          text-align: center;
          color: white;
        }

        .spinner {
          width: 50px;
          height: 50px;
          margin: 0 auto 16px;
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .loading-spinner p {
          font-size: 1.1rem;
          font-weight: 600;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .latest-hero {
            padding: 50px 20px;
          }

          .latest-container {
            padding: 40px 20px;
          }

          .categories-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }

          .category-card-inner {
            padding: 24px 20px 20px;
          }
        }

        @media (max-width: 480px) {
          .latest-hero-title {
            font-size: 1.8rem;
          }

          .category-icon-wrapper {
            width: 80px;
            height: 80px;
          }

          .category-icon-img {
            width: 52px;
            height: 52px;
          }
        }
           /* ============================================
           REMOVE TOP WHITE SPACE
        ============================================ */
        body {
          margin: 0 !important;
          padding: 0 !important;
        }
      `}</style>
    </div>
  );
};

export default LatestLaw;